import { OrderOperations } from "./OrderOperations"
import {
  OrderModificationAddresses,
  OrderModificationOrderLines,
  OrderModificationShippingFees,
  OrderModificationType
} from "lib/types/generated/graphql-types"
import { AddressType } from "lib/types/order"

export class ModificationAddresses extends OrderOperations {
  constructor(
    modification: (
      | OrderModificationShippingFees
      | OrderModificationAddresses
      | OrderModificationOrderLines
    )[]
  ) {
    super(modification?.filter((m) => m?.type === OrderModificationType.OrderAddresses))
  }

  public onGoingModifications(): OrderModificationAddresses[] {
    return this.onGoingList() as OrderModificationAddresses[]
  }

  public failedModifications(): OrderModificationAddresses[] {
    return this.failedList() as OrderModificationAddresses[]
  }

  public getOngoingModification(): OrderModificationAddresses {
    const onGoingList = this.onGoingList() as OrderModificationAddresses[]
    return onGoingList[0]
  }

  public getOnGoingModificationType(): AddressType | null {
    if (this.getOngoingModification().addresses.data.billingAddress)
      return AddressType.BILLING_ADDRESS
    if (this.getOngoingModification().addresses.data.shippingAddress)
      return AddressType.SHIPPING_ADDRESS
    return null
  }

  public getPendingModification(): OrderModificationAddresses {
    const pendingList = this.pendingList() as OrderModificationAddresses[]
    return pendingList[0]
  }
}
